import { HttpParams } from '@angular/common/http';
import { Params } from '@angular/router';

export function updateParamsObject(params: HttpParams, resetPage: boolean = false) {
  const paramsObject: Params = {};
  if (params.keys()) {
    for (const key of params.keys()) {
      const value = params.get(key);
      paramsObject[key] = value === 'null' ? null : value;
    }
  }

  if (resetPage) paramsObject['page'] = '1';

  return paramsObject;
}

/**
 * Helper function to update a params object and automatically reset page to 1.
 * Use this when applying filters to ensure pagination resets to the first page.
 */
export function updateParamsObjectToPageOne(params: HttpParams) {
  return updateParamsObject(params, true);
}

export function arrayStringToNumber(arr: string[]) {
  const result: number[] = [];
  for (const i of arr) {
    result.push(+i);
  }
  return result;
}
